/**
 * Whay (Mauritania) brand locale + product constants — single source of truth.
 *
 * This dashboard is the Whay Mauritania deployment; values mirror the
 * user-mobile-app (`constants/Phone.ts`, `constants/Map.ts`, i18n
 * `common.currency`).
 *
 * NOTE: whay-mu-specific. `main` is the Ohay brand's other regional
 * deployment and keeps its own currency/country/locale defaults — do not
 * copy these values back to `main`.
 */

export const CURRENCY = "MRU"; // Mauritanian ouguiya (ISO 4217)
export const CURRENCY_LOCALE = "en-US"; // app formats with en-US + Latin digits
export const COUNTRY_CODE = "+222";
export const COUNTRY_NAME = "Mauritania";
export const CITY_NAME = "Nouakchott, Mauritania";

/** Canonical form: 8 digits, mobile prefix 2/3/4. */
export const PHONE_REGEX = /^[234]\d{7}$/;
export const PHONE_ERROR = "Please enter a valid 8-digit phone number";
export const PHONE_PLACEHOLDER = "Phone number (e.g. 22XXXXXX)";

/** Nouakchott city centre — mirrors mobile constants/Map.ts CITY_CENTER. */
export const DEFAULT_MAP_CENTER: [number, number] = [18.0735, -15.9582];
